import { roleLabel, USER_ROLE_OPTIONS } from "../superAdminRules";
import { Field, PasswordConditions, RoleOptions, setField } from "../SuperAdminCommon";
import { btnBlackStyle, btnOutlineStyle, errorStyle, inputStyle, insetFormStyle } from "../superAdminStyles";

function RoleSelect({ value, onChange }) {
    return (
        <div style={{ flex: "0 0 160px" }}>
            <Field label="Rôle *">
                <select style={inputStyle} value={value} onChange={onChange}>
                    <RoleOptions roles={USER_ROLE_OPTIONS} label={roleLabel} />
                </select>
            </Field>
        </div>
    );
}

export function UserCreateForm({ userForm, setUserForm, userSubmitting, onSubmit }) {
    return (
        <form onSubmit={onSubmit} noValidate aria-label="Créer un utilisateur" style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end", padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0", marginBottom: "20px" }}>
            <div style={{ flex: "1 1 180px" }}>
                <Field label="Email *">
                    <input style={inputStyle} type="email" value={userForm.email} onChange={setField(setUserForm, "email")} required />
                </Field>
            </div>
            <div style={{ flex: "1 1 180px" }}>
                <Field label="Mot de passe *">
                    <input style={inputStyle} type="password" value={userForm.password} onChange={setField(setUserForm, "password")} required />
                    <PasswordConditions password={userForm.password} />
                </Field>
            </div>
            <RoleSelect value={userForm.role} onChange={setField(setUserForm, "role")} />
            <button type="submit" disabled={userSubmitting} style={btnBlackStyle}>
                {userSubmitting ? "Création..." : "Créer l'utilisateur"}
            </button>
        </form>
    );
}

export function UserEditForm({ editor }) {
    const { editUserForm, setEditUserForm } = editor;
    return (
        <form onSubmit={editor.handleEditUser} noValidate aria-label="Modifier l'utilisateur" style={{ ...insetFormStyle, padding: "16px", display: "flex", flexWrap: "wrap", gap: "14px", alignItems: "flex-end" }}>
            <div style={{ flex: "1 1 180px" }}>
                <Field label="Email *">
                    <input style={inputStyle} type="email" value={editUserForm.email} onChange={setField(setEditUserForm, "email")} required />
                </Field>
            </div>
            <RoleSelect value={editUserForm.role} onChange={setField(setEditUserForm, "role")} />
            <div style={{ flex: "1 1 180px" }}>
                <Field label="Nouveau mot de passe" hint="vide = conserver">
                    <input style={inputStyle} type="password" value={editUserForm.password} onChange={setField(setEditUserForm, "password")} autoComplete="new-password" />
                </Field>
            </div>
            {editor.editUserError && <p style={{ ...errorStyle, width: "100%", margin: 0 }}>{editor.editUserError}</p>}
            <div style={{ display: "flex", gap: "8px" }}>
                <button type="submit" disabled={editor.editUserSaving} style={btnBlackStyle}>{editor.editUserSaving ? "Sauvegarde..." : "Sauvegarder"}</button>
                <button type="button" onClick={editor.cancelEditUser} style={btnOutlineStyle}>Annuler</button>
            </div>
        </form>
    );
}
